<template>
  <form v-if="previewOrderData.countryAndCountyData" @submit="validateForm" method="post" ref="checkoutForm">
    <AdvGiftChoiceModalV2
      ref="AdvGiftChoiceModalV2"
      form-submit-handle="preview_submit"
    >
    </AdvGiftChoiceModalV2>
    <GenericModal
      v-if="displayLocalErrors"
      :unique-id="`CheckoutErrors`"
      :ref="'CheckoutErrorsModal'"
      :has-header="false"
      :has-footer="false"
      :close-btn-color="'#ef1b1b'"
      :width="'780px'"
      :max-height="'520px'"
    >
      <CheckoutErrors
        :errors="localErrors"
      >
      </CheckoutErrors>
    </GenericModal>
    <div class="container previewOrderContainer">
      <div class="row">
        <div v-if="!previewOrderData.isCustomerLoggedIn" class="col-12 prev-order-user-tabs">
          <div class="btn-group btn-group-toggle w-100">
            <label class="btn focus" :class="customerData.is_guest === '1' ? 'active' : ''">
              <input type="radio" name="is_guest" value="1" v-model="customerData.is_guest">
              {{ t('preview.order.main.tab.guest.lbl') }}
            </label>
            <label class="btn focus" :class="customerData.is_guest === '0' ? 'active' : ''">
              <input type="radio" name="is_guest" value="0" v-model="customerData.is_guest">
              {{ t('preview.order.main.tab.register.buy') }}
            </label>
            <label class="btn launch-login">
              <input type="radio">
              {{ t('preview.order.main.tab.account.login') }}
            </label>
          </div>
        </div>

        <div class="col-12 col-lg-7">
          <div>
            <div id="customerOrderDetails" class="checkout-form-block">
              <div class="row">
                <div class="col-12 checkout-form-header">
                  <span class="checkout-form-title">{{ t('preview.order.order.details') }}</span>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="name">{{ t('customer.name') }}:</label>
                  <input type="text" id="name" name="name" class="form-control"
                         v-model="customerData.name"
                         :data-field_name="t('customer.name')"
                         :placeholder="t('customer.name')" required>
                  <check-out-form-error :error="errors.name || localErrors.name || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="surname">{{ t('customer.surname') }}:</label>
                  <input type="text" name="surname" id="surname" class="form-control"
                         :data-field_name="t('customer.surname')"
                         v-model="customerData.surname"
                         :placeholder="t('customer.surname')" required>
                  <check-out-form-error :error="errors.surname || localErrors.surname || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="company">{{ t('customer.company') }}:</label>
                  <input type="text" id="company" name="company" class="form-control"
                         :class="previewOrderData.invoiceType === 'invoice' && customerData.company_name === '' ? 'is-invalid' : ''"
                         v-model="customerData.company_name" :placeholder="t('customer.company')">
                  <check-out-form-error :error="errors.company || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="landphone">{{ t('customer.phone') }}:</label>
                  <input type="text" name="landphone" id="landphone" class="form-control"
                         v-model="customerData.landphone"
                         :data-field_name="t('customer.phone')"
                         :placeholder="t('customer.phone')"
                         @input="sanitizePhoneNumber" required>
                  <check-out-form-error :error="errors.landphone || localErrors.landphone || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col d-none">
                  <label for="mobilephone">{{ t('customer.phone2') }}:</label>
                  <input type="text" name="mobilephone" id="mobilephone" class="form-control"
                         v-model="customerData.mobilephone"
                         :placeholder="t('customer.phone2')"
                         @input="sanitizePhoneNumber">
                  <check-out-form-error :error="errors.mobilephone || ''"></check-out-form-error>
                </div>

                <div v-show="!previewOrderData.isCustomerLoggedIn" class="col-12 form-group  checkout-form-col">
                  <label for="mail">{{ t('customer.email') }}:</label>
                  <input
                    type="email"
                    name="mail"
                    id="mail"
                    class="form-control"
                    v-model="customerData.mail"
                    :data-field_name="t('customer.email')"
                    :required="!previewOrderData.isCustomerLoggedIn"
                  >
                  <check-out-form-error :error="errors.mail || localErrors.mail || ''"></check-out-form-error>
                </div>
              </div>

              <div v-show="!previewOrderData.isCustomerLoggedIn" class="row">
                <div v-show="customerData.is_guest === '0'" class="col-12 col-md-6 checkout-form-col passwordInputField">
                  <label for="password">{{ t('customer.password') }}:</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    class="form-control"
                    v-model="password"
                    :placeholder="t('customer.password')"
                    :data-field_name="t('customer.password')"
                    :required="passwordRequired"
                  >
                  <check-out-form-error :error="errors.password || localErrors.password || ''"></check-out-form-error>
                </div>
                <div v-show="customerData.is_guest === '0'" class="col-12 col-md-6 checkout-form-col passwordInputField">
                  <label for="password_retype">{{ t('customer.password.repeat') }}:</label>
                  <input
                    type="password"
                    name="password_retype"
                    id="password_retype"
                    class="form-control"
                    v-model="passwordVerify"
                    :placeholder="t('customer.password.repeat')"
                    :data-field_name="t('customer.password.repeat')"
                    :required="passwordRequired"
                  >
                  <check-out-form-error :error="passwordRetype || localErrors.password_retype || ''"></check-out-form-error>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="city">{{ t('customer.city') }}:</label>
                  <input type="text" name="city" id="city" class="form-control"
                         v-model="customerData.city"
                         :data-field_name="t('customer.city')"
                         :placeholder="t('customer.city')" required>
                  <check-out-form-error :error="errors.city || localErrors.city || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="postal">{{ t('customer.postal.index') }}:</label>
                  <input type="text" name="postal" id="postal" class="form-control"
                         :data-field_name="t('customer.postal.index')"
                         v-model="customerData.postal" :placeholder="t('customer.postal.index')" required>
                  <check-out-form-error :error="errors.postal || localErrors.postal || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="address">{{ t('customer.address') }}:</label>
                  <input type="text" name="address" id="address" class="form-control"
                         :data-field_name="t('customer.address')"
                         v-model="customerData.address" :placeholder="t('customer.address')" required>
                  <check-out-form-error :error="errors.address || localErrors.address || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="afm">{{ t('customer.afm') }}:</label>
                  <input type="text" name="afm" id="afm" class="form-control"
                         :class="previewOrderData.invoiceType === 'invoice' && customerData.company_afm === '' ? 'is-invalid' : ''"
                         v-model="customerData.company_afm" :placeholder="t('customer.afm')">
                  <check-out-form-error :error="errors.afm || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col d-none">
                  <label for="region">{{ t('customer.region') }}:</label>
                  <input type="text" name="region" id="region" class="form-control"
                         v-model="customerData.region" :placeholder="t('customer.region')">
                  <check-out-form-error :error="errors.region || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="country">{{ t('customer.country') }}:</label>
                  <select
                    name="country"
                    id="country"
                    class="form-control dropdown_custom_field"
                    v-model="customerData.country"
                    :data-field_name="t('customer.country')"
                    @change="onChangeCounty() && validateVat({'country': customerData.country, 'vat':customerData.company_afm})"
                    required
                  >
                    <option v-for="(countryValue, countryKey, index) in previewOrderData.countryAndCountyData.country"
                            :key="index" :value="countryKey">{{ countryValue }}</option>
                  </select>
                  <check-out-form-error :error="errors.country || localErrors.country || ''"></check-out-form-error>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="county">{{ t('customer.area') }}:</label>
                  <select
                    name="county"
                    id="county"
                    class="form-control dropdown_custom_field"
                    v-model="customerData.county"
                    :data-field_name="t('customer.area')"
                    required
                  >
                    <option disabled value="">{{ t('selectCounty') }}</option>
                    <option v-for="(countiesValue, countyKey, index) in availableCounties"
                            :key="index" :value="countyKey">{{ countiesValue }}</option>
                  </select>
                  <check-out-form-error :error="errors.county || localErrors.county || ''"></check-out-form-error>
                </div>
              </div>
            </div>
          </div>
          <div id="customerInvoiceType">
            <div class="custom-control custom-radio custom-control-inline d-none">
              <input name="paymerch" value="invoice"  type="radio" id="invoicecheck"
                     class="custom-control-input" v-model="previewOrderData.invoiceType">
              <label class="custom-control-label" for="invoicecheck">
                {{ t('preview.order.invoice.type.invoice') }}
              </label>
            </div>
          </div>
          <div v-show="!getSmartPointIsSelected" id="customerOrderShippingDetails" class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-form-header">
                <span class="checkout-form-title">{{ t('preview.order.delivery.details') }}</span>
              </div>
              <div class="col-12 customerOrderShippingDetailsCheckbox">
                <div class="checkbox">
                  <input type="checkbox"
                         class="checkbox_input"
                         id="sameaddress"
                         name="sameaddress"
                         value="1"
                         v-model="sameShipping">
                  <label class="checkbox_label" for="sameaddress">
                    {{ t('preview.order.delivery.details.same') }}
                  </label>
                </div>
              </div>
            </div>
            <div id="shippingDetails" class="row" v-show="!sameShipping">
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_name">{{ t('customer.name') }}:</label>
                <input type="text" id="sendto_name" name="sendto_name" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_name === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_name" :placeholder="t('customer.name')">
                <check-out-form-error :error="errors.sendto_name || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_surname">{{ t('customer.surname') }}:</label>
                <input type="text" id="sendto_surname" name="sendto_surname" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_surname === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_surname" :placeholder="t('customer.surname')">
                <check-out-form-error :error="errors.sendto_surname || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_landphone">{{ t('customer.phone') }}:</label>
                <input type="text" id="sendto_landphone" name="sendto_landphone" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_landphone === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_landphone" :placeholder="t('customer.phone')">
                <check-out-form-error :error="errors.sendto_landphone || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_mobilephone">{{ t('customer.phone2') }}:</label>
                <input type="text" id="sendto_mobilephone" name="sendto_mobilephone" class="form-control"
                       v-model="customerData.sendto_mobilephone" :placeholder="t('customer.phone2')">
                <check-out-form-error :error="errors.sendto_mobilephone || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_city">{{ t('customer.city') }}:</label>
                <input type="text" id="sendto_city" name="sendto_city" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_city === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_city" :placeholder="t('customer.city')">
                <check-out-form-error :error="errors.sendto_city || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_postal">{{ t('customer.postal.index') }}:</label>
                <input type="text" id="sendto_postal" name="sendto_postal" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_postal === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_postal" :placeholder="t('customer.postal.index')">
                <check-out-form-error :error="errors.sendto_postal || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_address">{{ t('customer.address') }}:</label>
                <input type="text" name="sendto_address" id="sendto_address" class="form-control"
                       :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_address === '' ? 'is-invalid' : ''"
                       v-model="customerData.sendto_address" :placeholder="t('customer.address')">
                <check-out-form-error :error="errors.sendto_address || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_region">{{ t('customer.region') }}:</label>
                <input type="text" name="sendto_region" id="sendto_region" class="form-control"
                       v-model="customerData.sendto_region" :placeholder="t('customer.region')">
                <check-out-form-error :error="errors.sendto_region || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_country">{{ t('customer.country') }}:</label>
                <select name="sendto_country" id="sendto_country" class="form-control dropdown_custom_field"
                        :class="this.useAddress === orderAddressOptions.shipping && !customerData.sendto_country ? 'is-invalid' : ''"
                        v-model="customerData.sendto_country" @change="onChangeSendToCounty">
                  <option disabled value="">{{ t('selectCountry') }}</option>
                  <option v-for="(countryValue, countryKey, index) in previewOrderData.countryAndCountyData.country"
                          :key="index" :value="countryKey">{{ countryValue }}</option>
                </select>
                <check-out-form-error :error="errors.sendto_country || ''"></check-out-form-error>
              </div>
              <div class="col-12 col-md-6 checkout-form-col">
                <label for="sendto_county">{{ t('customer.area') }}:</label>
                <select name="sendto_county" id="sendto_county" class="form-control dropdown_custom_field"
                        :class="this.useAddress === orderAddressOptions.shipping && customerData.sendto_county === '' ? 'is-invalid' : ''"
                        v-model="customerData.sendto_county">
                  <option disabled value="">{{ t('selectCounty') }}</option>
                  <option v-for="(itemValue, itemKey) in availableCountiesShipping"
                          :key="itemKey" :value="itemKey">{{ itemValue }}</option>
                </select>
                <check-out-form-error :error="errors.sendto_county || ''"></check-out-form-error>
             </div>
            </div>
          </div>
          <div id="customerNotes" class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-notes-col">
                <span class="preview-order-form-subtitle">
                    <label for="customer_notes"> {{ t('preview.order.textarea.order.notes') }}:</label>
                </span>
                <textarea class="form-control" rows="2" id="customer_notes" name="customer_notes" v-model="customerData.customerNotes"></textarea>
                <check-out-form-error :error="errors.customer_notes || ''"></check-out-form-error>
              </div>
              <div class="col-12 checkout-notes-col">
                <span class="preview-order-form-subtitle">
                  <label for="courier_notes">{{ t('preview.order.textarea.delivery.notes') }}:</label>
                </span>
                <textarea class="form-control" rows="2" id="courier_notes" name="courier_notes" v-model="customerData.courierNotes"></textarea>
                <check-out-form-error :error="errors.courier_notes || ''"></check-out-form-error>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5 checkout-side">
          <div id="customerPaymentMethods" class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-form-header">
                  <span class="checkout-form-title">
                    {{ t('preview.order.payment.method') }}
                    <check-out-form-error :error="errors.order_total || ''"></check-out-form-error>
                  </span>
              </div>

              <template v-for="payWay in validPayWays">
                <div class="custom-control custom-radio" :key="payWay.key">
                  <input name="payway"
                         :value="payWay.key"
                         type="radio"
                         :id="payWay.key"
                         class="custom-control-input"
                         v-on:change="setDeliveryBasedOnPayWay"
                         v-model="previewOrderData.payWay"
                         :disabled="!isPayWayOptionAvailable(payWay.key)"
                  >
                  <label class="custom-control-label" :for="payWay.key">
                    {{ t(payWay.localeKey) }}
                    <small v-if="payWay.key === 'delivery' && deliveryCostVerbal > 0" v-html="
                      '(' + (deliveryCostVerbal * getSelectedCurrency.rate).toFixed(2) + getSelectedCurrency.symbol + ')' "/>
                    <span v-if="payWay.key === 'paid_at_store' && !isCartTotalAbovePaidAtStoreMinCartTotalLimit" class="minimum-cart">
                      ({{ t('preview.order.minimum_cart_alert', { params: [{ minCartTotalForPaidAtStore: previewOrderData.minCartTotalAmountForPaidAtStore, }] }) }})
                    </span>
                  </label>
                </div>

                <div v-if="payWay.key === 'apcopay' && Object.keys(previewOrderData.apcoInstallments).length > 0" :key="'apco' + payWay.key"
                     class="col-12 checkout-form-col" v-show="previewOrderData.payWay === 'apcopay'">
                  <label for="apco-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="apco-form-installments" class="form-control" v-model="apcoInstallments">
                    <option v-for="(installmentLabel, installmentKey) in previewOrderData.apcoInstallments"
                            :key="'apco' + installmentKey" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>

                <div v-if="payWay.key === 'piraeus' && Object.keys(previewOrderData.piraeusInstallments).length > 1 && previewOrderData.piraeusInstallments.minimumOrderTotal <= orderTotal" :key="'piraeus' + payWay.key"
                     class="col-12 checkout-form-col" v-show="previewOrderData.payWay === 'piraeus'">
                  <label for="piraeus-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="piraeus-form-installments" class="form-control" v-model="piraeusInstallments">
                    <option v-for="(installmentLabel, installmentKey) in previewOrderData.piraeusInstallments.installments"
                            :key="'piraeus' + installmentKey" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>

                <div v-if="payWay.key === 'eurobank' && Object.keys(previewOrderData.eurobankInstallments.installments).length > 1 && previewOrderData.eurobankInstallments.minimumOrderTotal <= orderTotal" :key="'eurobank' + payWay.key"
                     class="col-12 checkout-form-col" v-show="previewOrderData.payWay === 'eurobank'">
                  <label for="eurobank-form-installments" class="orderFldLbl">
                    {{ t('eshop.front.checkout.installments') }}
                  </label>
                  <select name="installments" id="eurobank-form-installments" class="form-control" v-model="eurobankInstallments">
                    <option v-for="(installmentLabel, installmentKey) in previewOrderData.eurobankInstallments.installments"
                            :key="'eurobank' + installmentKey" :value="installmentKey">{{ installmentLabel }}</option>
                  </select>
                </div>

              </template>
              <check-out-form-error :error="errors.payway"></check-out-form-error>
            </div>
          </div>
          <div id="customerDeliveryMethod" class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-form-header">
                <check-out-form-error :error="errors.transport_id || ''"></check-out-form-error>
                <span class="checkout-form-title">
                  {{ t('preview.order.choose.delivery.method') }}
                  <check-out-form-error :error="errors.order_total || ''"></check-out-form-error>
                </span>
                <div class="custom-control custom-radio">
                  <input name="courier_address"
                         :class="isCourierAddress === '1' && !previewOrderData.transporterId ? 'is-invalid' : ''"
                         value="1"
                         type="radio"
                         id="customRadio8"
                         class="custom-control-input"
                         v-model="isCourierAddress"
                         :disabled="previewOrderData.payWay === 'paid_at_store'">
                  <label class="custom-control-label" for="customRadio8">
                    {{ t('preview.order.send.by.courier') }}
                  </label>

                  <adv-order-transporters
                    id="order-transporters"
                    v-show="isCourierAddress === '1'"
                    :country="orderCountry"
                    :county="orderCounty"
                    :postal="orderPostal"
                    v-on:set-input="setTransporterId"
                    @change="setPayWayAfterTransporterUpdate"
                    v-model="previewOrderData.transporterId"></adv-order-transporters>
                </div>

                <div v-if="activeStores.length > 0" class="custom-control custom-radio">
                  <input name="courier_address"
                         :class="isCourierAddress === '0' && activeStores.length > 1 && !previewOrderData.storeId ? 'is-invalid' : ''"
                         value="0"
                         type="radio"
                         id="courierAddressPickupAtStoreRadio"
                         class="custom-control-input"
                         v-model="isCourierAddress"
                         :disabled="previewOrderData.payWay === 'delivery' || !isCartTotalAbovePaidAtStoreMinCartTotalLimit">
                  <label class="custom-control-label" for="courierAddressPickupAtStoreRadio">
                    {{ activeStores.length === 1 ? t('preview.order.pickup.at.store') + '(' + activeStores[0].storeLabel + ')' : t('preview.order.pickup.at.store')}}
                    <span v-if="!isCartTotalAbovePaidAtStoreMinCartTotalLimit" class="minimum-cart">
                      ({{ t('preview.order.minimum_cart_alert', { params: [{ minCartTotalForPaidAtStore: previewOrderData.minCartTotalAmountForPaidAtStore, }] }) }})
                    </span>
                  </label>
                  <check-out-form-error :error="errors.store || ''"></check-out-form-error>

                  <div v-if="this.previewOrderData.payWay === 'paid_at_store' || this.useAddress === '2'">
                    <input v-if="activeStores.length === 1" type="hidden" name="store" :value="activeStores[0].id">
                    <div v-else id="store_selectors_container" v-show="isCourierAddress === '0'">
                      <div v-for="storeData in activeStores" :key="storeData.store_id" class="custom-control custom-radio">
                        <input name="store"
                               :value="storeData.store_id"
                               type="radio"
                               :id="'storeRadio' + storeData.store_id"
                               class="custom-control-input"
                               v-model="previewOrderData.storeId">
                        <label class="custom-control-label" :for="'storeRadio' + storeData.store_id">
                          {{ storeData.storeLabel }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <checkout-coupon id="customerCouponRedeem" :coupon-code="previewOrderData.couponCode" class="checkout-form-block"></checkout-coupon>

          <div v-if="showPointsBlocks" id="customerPointsRedeem" class="checkout-form-block">
            <div class="row">
              <div class="col-12 checkout-form-header">
                <span class="checkout-form-title">{{ t('preview.order.points.redeem') }}</span>
              </div>
              <div class="col-12 points-redeem-info">
                <p v-html="t('preview.order.points', { params: [{
                    totalPoints: previewOrderData.loyalty.customerTotalPoints,
                    points: previewOrderData.loyalty.customerPoints,
                    cash: Number(previewOrderData.loyalty.customerCash).toFixed(2) + currencySign
                  }] })">
                </p>
              </div>
              <div class="col-12 col-lg-6 points-redeem-check-row">
                <div class="checkbox">
                  <input id="js-points-check" type="checkbox" class="checkbox_input"
                         name="redeemPoints" value="1" v-model="redeemPoints">
                  <label for="js-points-check" class="checkbox_label">{{ t('preview.order.points.checkbox.label') }}</label>
                  <check-out-form-error :error="errors.redeemPoints || ''"></check-out-form-error>
                </div>
              </div>
            </div>
          </div>

          <div id="customerCartPreview" class="checkout-form-block">
            <div class="row row-mlr-0">
              <div class="col-12 checkout-form-header">
                <span class="checkout-form-title">
                  {{ t('preview.order.cart.preview') }}
                  <span id="checkout-prods-no" v-if="cartEmpty" v-cloak>
                    {{ cartProductsCount }}
                  </span>
                </span>
              </div>
              <div class="col-12 checkout-mini-cart">
                <div class="row row-mlr-0">
                  <adv-cart :read-only="true" :mini-cart="true" :disable-product-links="true"></adv-cart>
                </div>
              </div>

              <div class="col-12 checkout-costs-block">
                <div class="row row-mlr-0">
                  <div v-show="showPointsBlocks" class="col-12 preview-costs-row" id="js-points-info-row">
                    <span class="prev_cost_ttl">{{ t('discount_from_points') }}:</span> <span class="prev-order-value">{{ Number(customerPointsRedeemValue * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}
                  </div>

                  <div class="col-12 preview-costs-row">
                    <span class="prev_cost_ttl">{{ t('checkout.coupon_discount') }}:</span> <span class="prev-order-value" id="js-coupon-value">{{ (couponDiscount * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}
                  </div>
                  <div class="col-12 preview-costs-row">
                    <span class="prev_cost_ttl">{{ t('checkout.shipping_costs') }}:</span> <span class="prev-order-value" id="js-transport-cost">{{ (transportationCost * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}
                  </div>
                  <div v-show="overweightCost>0" class="col-12 preview-costs-row">
                    <span class="prev_cost_ttl">{{ t('overweight_cost') }}:</span> <span class="prev-order-value" id="js-overweight-cost">{{ (overweightCost * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}
                  </div>
                  <div class="col-12 preview-costs-row">
                    <span class="prev_cost_ttl">{{ t('checkout.cash_on_delivery_costs') }}:</span> <span class="prev-order-value" id="js-delivery-cost">{{ (deliveryCost * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}
                  </div>
                  <div class="col-12 text-right preview-costs-row total-checkout-cost-row">
                    <div v-if="!this.previewOrderData.hideVat">{{ t('checkout.total_without_vat')}}: <span>{{ (orderTotalWithoutVat * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}<br/></div>
                    <div v-if="!this.previewOrderData.hideVat">{{ t('checkout.vat')}}: <span>{{ (orderVat * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}<br/></div>
                    <div class="d-inline-flex">
                      <span v-if="!this.previewOrderData.hideVat">{{ t('checkout.total_vat')}}</span>
                      <span v-else>{{ t('total')}}</span>
                      : <span id="js-order-total">{{ (orderTotal * getSelectedCurrency.rate).toFixed(2) }}</span>{{ getSelectedCurrency.code }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <adv-reactive-form-input-manipulator
        state-getter-reference="getSelectedGiftItemsForReactiveFormManipulator"></adv-reactive-form-input-manipulator>
      <adv-gift-choice-block form-submit-handle="preview_submit"></adv-gift-choice-block>
      <div id="customerFormSubmit" class="checkout-form-block">
        <div class="row">
          <div class="col-12 col-md-6 prev-terms-row">
            <div class="row">
              <div class="col-12 checkbox newsletterAgree" v-if="previewOrderData.displayManagoNewsletterCheckbox">
                <input id="register_newsletter"
                       type="checkbox"
                       class="checkbox_input"
                       name="register_newsletter"
                       v-model="newsletterRegister"
                       :value="newsletterRegister"
                >
                <label for="register_newsletter" class="checkbox_label">
                  {{ t('preview.order.newsletter_register') }}
                </label>
              </div>
              <div class="col-12  checkbox termsAgree">
                <input
                  id="termsacceptcheck"
                  type="checkbox"
                  class="checkbox_input"
                  required
                  name="accept_terms"
                  :data-field_name="t('customer.register.terms')"
                  v-model="termsChecked"
                >
                <label for="termsacceptcheck" class="checkbox_label">
                  {{ t('customer.register.terms.agree') }}
                  <a target="_blank" :href="t('customer.register.terms.link.href')">
                    {{ t('customer.register.terms.link') }}
                  </a>
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-xl-4 ml-auto checkout-submit-row text-right">
            <button class="submit-btn" name="preview_submit" value="true" formnovalidate>
              {{ t('preview.order.continue') }}
            </button>
          </div>
          <input type="hidden" name="order_total" v-model="cartProductsTotal">
          <input type="hidden" name="order_currency" :value="getSelectedCurrency.code">
          <input type="hidden" name="currency_id" :value="getSelectedCurrency.id">
          <input type="hidden" name="currency_rate" :value="getSelectedCurrency.rate">
          <input type="hidden" name="useAddress" :value="useAddress">
        </div>
      </div>
        </div>
      </div>
    </div>
    <div class="modal fade mt-10" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-html="t('checkout.transporters.modal')"></p>
            <a :href="t('checkout.transporters.modal.category_link')" >{{t('checkout.transporters.modal.view_more')}}</a>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{t('checkout.transporters.modal.close')}}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import AdvCart from './AdvCart'
import AdvGiftChoiceBlock from './AdvGiftChoiceBlock'
import CheckoutErrors from './CheckoutErrors'
import AdvReactiveFormInputManipulator from './AdvReactiveFormInputManipulator'
import AdvOrderTransporters from './AdvOrderTransporters'
import CheckOutFormError from './CheckOutFormError'
import CheckoutCoupon from './CheckoutCoupon'
import checkoutPage from '../../vue/mixins/checkoutPage'
import orderAddressOptions from '../../vue/api/orderAddressOptions'
import GenericModal from './presentation/GenericModal'
import AdvGiftChoiceModalV2 from '../../design/vue/AdvGiftChoiceModalV2'

export default {
  name: 'CheckoutPage',
  mixins: [checkoutPage],
  components: {
    AdvCart,
    CheckOutFormError,
    AdvGiftChoiceModalV2,
    AdvReactiveFormInputManipulator,
    AdvGiftChoiceBlock,
    AdvOrderTransporters,
    CheckoutCoupon,
    GenericModal,
    CheckoutErrors
  },
  data () {
    return {
      orderAddressOptions: orderAddressOptions
    }
  }
}
</script>
